<template>
  <div>
    <MasterLayout>
      <div class="fuelbalance_first_row">
        <div class="card_container" style="border-radius: 17px">
          <div class="card__header___text">
            <div>
              <h3 class="our_branches__header">
                {{ $t("text.shiftDeposits.totalShiftDeposit") }}
              </h3>
              <div class="dealer__icon__wrapper mt-3">
                <div class="dealer__icon__div text-center">
                  <div>
                    <img src="@/assets/img/wallet.svg" width="35px" />
                  </div>
                </div>
              </div>
              <div class="text-center mt-3">
                <h3>{{ count }}</h3>
              </div>
            </div>
          </div>
        </div>
        <div
          class="fuelbalance_first_row_right_section mr-3 co_dealer"
          style="border-radius: 22px"
          :style="[
            {
              backgroundImage: `linear-gradient(rgb(12, 4, 31 , 0.7), rgb(12, 4, 31 , 0.7)), url(${backgroundUrl})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            },
          ]"
        >
          <div class="our__branches__banner">
            <div class="row align-items-center section__row">
              <div class="col-md-12 text-center section___column_1">
                <h2 class="our__branches__banner__title">
                  {{ $tc("text.shiftDeposits.shiftDeposits", 2) }}
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section class="mt-3 pump__details__section_2">
        <div class="row add_driver_row">
          <div class="col-md-12 col-lg-8">
            <table v-if="showLoader" style="margin: 0 auto; width: 95%">
              <tbody>
                <tr>
                  <td class="td-1"><span></span></td>
                  <td class="td-2"><span></span></td>
                  <td class="td-3"><span></span></td>
                  <td class="td-4"></td>
                  <td class="td-5"><span></span></td>
                </tr>
                <tr>
                  <td class="td-1"><span></span></td>
                  <td class="td-2"><span></span></td>
                  <td class="td-3"><span></span></td>
                  <td class="td-4"></td>
                  <td class="td-5"><span></span></td>
                </tr>
                <tr>
                  <td class="td-1"><span></span></td>
                  <td class="td-2"><span></span></td>
                  <td class="td-3"><span></span></td>
                  <td class="td-4"></td>
                  <td class="td-5"><span></span></td>
                </tr>
                <tr>
                  <td class="td-1"><span></span></td>
                  <td class="td-2"><span></span></td>
                  <td class="td-3"><span></span></td>
                  <td class="td-4"></td>
                  <td class="td-5"><span></span></td>
                </tr>
                <tr>
                  <td class="td-1"><span></span></td>
                  <td class="td-2"><span></span></td>
                  <td class="td-3"><span></span></td>
                  <td class="td-4"></td>
                  <td class="td-5"><span></span></td>
                </tr>
                <tr>
                  <td class="td-1"><span></span></td>
                  <td class="td-2"><span></span></td>
                  <td class="td-3"><span></span></td>
                  <td class="td-4"></td>
                  <td class="td-5"><span></span></td>
                </tr>
                <tr>
                  <td class="td-1"><span></span></td>
                  <td class="td-2"><span></span></td>
                  <td class="td-3"><span></span></td>
                  <td class="td-4"></td>
                  <td class="td-5"><span></span></td>
                </tr>
                <tr>
                  <td class="td-1"><span></span></td>
                  <td class="td-2"><span></span></td>
                  <td class="td-3"><span></span></td>
                  <td class="td-4"></td>
                  <td class="td-5"><span></span></td>
                </tr>
                <tr>
                  <td class="td-1"><span></span></td>
                  <td class="td-2"><span></span></td>
                  <td class="td-3"><span></span></td>
                  <td class="td-4"></td>
                  <td class="td-5"><span></span></td>
                </tr>
              </tbody>
            </table>
            <ejs-grid
              v-show="!showLoader"
              ref="dataGrid"
              :created="refreshGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="toolbarClick"
              :locale="usedLang"
            >
              <e-columns>
                <e-column width="60" field="index" headerText="#"></e-column>
                <e-column
                  width="220"
                  field="bank"
                  :headerText="$t('text.shiftDeposits.bank')"
                ></e-column>
                <e-column
                  field="amount"
                  width="200"
                  :headerText="$t('text.shiftDeposits.amount')"
                ></e-column>
                <e-column
                  field="balance"
                  width="200"
                  :headerText="$t('text.shiftDeposits.balance')"
                ></e-column>
                <e-column
                  field="teller_Number"
                  width="180"
                  :headerText="$t('text.shiftDeposits.tellerNumber')"
                ></e-column>
              </e-columns>
            </ejs-grid>
          </div>
          <div class="col-md-12 col-lg-4">
            <div style="background: white">
              <h3
                class="text-center"
                style="color: #4b2c72; padding-top: 15px; font-size: 20px"
              >
                {{ $tc("text.shiftDeposits.shiftDeposits", 1) }}
              </h3>
              <div class="input__group__block mt-5" style="width: 90%">
                <label class="required">
                  {{ $t("text.shiftDeposits.amount") }}
                </label>
                <div class="input__block" ref="amount_input_div">
                  <input
                    type="number"
                    :placeholder="this.$t('text.shiftDeposits.amount')"
                    class="form-control"
                    @blur="captureFormEvents($event)"
                    v-model="amount"
                  />
                </div>
                <div ref="amount_error"></div>
              </div>
              <div
                class="input__group__block mt-4"
                ref="account_textbox"
                style="width: 90%"
              >
                <label class="required">
                  {{ $t("text.shiftDeposits.bank") }}
                </label>
                <div class="input__block" ref="account_number_input_div">
                  <div class="input__block" ref="account_number_input_div">
                    <select v-model="bank">
                      <option disabled>
                        {{ $t("text.shiftDeposits.selectBank") }}
                      </option>
                      <option
                        :value="acc.name"
                        v-for="acc in bankAccounts"
                        :key="acc.id"
                      >
                        {{ acc.name }} ({{ acc.accountNumber }})
                      </option>
                    </select>
                    <div ref="recip_error"></div>
                  </div>
                </div>
              </div>
              <div class="input__group__block mt-5" style="width: 90%">
                <label class="required">
                  {{ $t("text.shiftDeposits.tellerNumber") }}
                </label>
                <div class="input__block" ref="amount_input_div">
                  <input
                    type="number"
                    :placeholder="this.$t('text.shiftDeposits.tellerNumber')"
                    class="form-control"
                    @blur="captureFormEvents($event)"
                    v-model="teller_Number"
                  />
                </div>
                <div ref="amount_error"></div>
              </div>
              <div class="text-center py-3 mt-3">
                <button
                  class="sales_target_btn text-center"
                  @click="createDeposit($event)"
                  :disabled="isButtonDisabled ? true : null"
                  :style="[
                    isButtonDisabled
                      ? { cursor: 'not-allowed' }
                      : { cursor: 'pointer' },
                  ]"
                >
                  {{ $t("text.shiftDeposits.submit") }}<span></span>
                </button>
                <img
                  src="@/assets/img/git_loader.gif"
                  style="display: none"
                  width="35px"
                  class="ml-3 loader"
                />
              </div>
              <div></div>
            </div>
          </div>
        </div>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Branch/MasterLayout.vue";
import backgroundUrl from "@/assets/img/Credit-card-background-shallow-DOF.png";
import configObject from "@/config";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
} from "@syncfusion/ej2-vue-grids";

export default {
  name: "Pump_Details",
  components: {
    MasterLayout,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport, Resize],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      openingRead: null,
      pumps: [],
      staffs: [],
      staff: this.$t("text.shiftDeposits.chooseStaff"),
      pump: this.$t("text.shiftDeposits.selectPump"),
      pumpId: this.$route.query.id,
      branch: {},
      pump: {},
      shiftName: null,
      shift: {},
      bank: "Select Bank",
      amount: "",
      balance: 0,
      teller_Number: null,
      tanks: [],
      backgroundUrl,
      shifts: [],
      formIsValid: false,
      isButtonDisabled: false,
      showLoader: false,
      branchId: null,
      search: { operator: "contains", ignoreCase: true },
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      shiftsDeposits: [],
      assignedShiftId: 0,
      staffList: [],
      pumpList: [],
      bankAccounts: [],
      shiftDepositCount: null,
    };
  },
  watch: {
    branch: function (newBranch, oldBranch) {
      if (newBranch.id) {
        this.branchId = this.branch.id;
      }
      if (this.branchId !== null) {
        this.getBankAccts();
        this.getShiftDeposits();

        $(".e-input").keyup(function (e) {
          searchFun(e);
        });
        function searchFun(event) {
          var grid =
            document.getElementsByClassName("e-grid")[0].ej2_instances[0];
          var value = event.target.value;
          grid.search(value);
        }
      }
    },
  },
  created() {
    document.title = "Shift Deposits:: Epump Retail Outlet";
    if (localStorage.getItem("userDetails") === "null") {
      this.$router.push({ path: "/" });
    } else if (configObject.authConfig() === null) {
      window.location.reload();
    }
    this.$eventHub.$on("branch", (branch) => {
      this.branch = branch;
      document.title = `Shift Deposits:: ${branch.name} Retail Outlet`;
    });
  },
  beforeDestroy() {},
  mounted() {},
  methods: {
    pumpChange(event) {
      this.openingRead = 0;
    },
    rowDataBound: function (args) {
      if (args.data["Closed"] === "true") {
        args.row.cells[4].innerHTML = "Shift Closed";
      }
    },
    closeThisShift(shift) {
      this.shift = shift;
      this.openCloseShift();
    },
    createDeposit(shift) {
      let shiftDetail = this.shifts.filter((sft) => sft.id === shift.id)[0];
      this.shift = shiftDetail;
      this.openAssignShiftModal();
    },
    openAssignShiftModal() {
      this.$modal.show("createDeposit");
    },
    openCloseShift() {
      this.$modal.show("closeShift");
    },
    changeRoute($newRoute) {
      this.$router.push({
        name: $newRoute,
        query: { branchId: this.branchId },
      });
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },

    createDeposit($event) {
      if (!this.bankAccounts.length) {
        this.$toast.open({
          message: this.$t("text.shiftDeposits.bankAccountError"),
          type: "error",
          duration: 7000,
        });
        return;
      }
      if (!this.amount) {
        this.$toast.open({
          message: this.$t("text.shiftDeposits.amountMissing"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      if (
        !this.bank ||
        this.bank === this.$t("text.shiftDeposits.selectBank")
      ) {
        this.$toast.open({
          message: this.$t("text.shiftDeposits.bankMissing"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      if (!this.teller_Number) {
        this.$toast.open({
          message: this.$t("text.shiftDeposits.tellerMissing"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      let data = {
        shiftId: this.$route.query.id,
        amount: parseFloat(this.amount),
        teller_Number: this.teller_Number,
        bank: this.bank,
        branchId: this.branchId,
      };
      this.isButtonDisabled = true;
      $(".loader").show();
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Branch/MakeShiftDeposit`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          this.isButtonDisabled = true;
          this.$toast.open({
            message: this.$t("text.shiftDeposits.successfullyCreated"),
            type: "success",
            duration: 5000,
          });
          $(".loader").hide();
          this.isButtonDisabled = false;
          this.getShiftDeposits();

          this.amount = 0;
          this.teller_Number = "";
          this.bank = "";
        })
        .catch(() => {
          this.$toast.open({
            message: this.$t("text.shiftDeposits.unsuccessfullyCreated"),
            type: "error",
            duration: 5000,
          });
          this.isButtonDisabled = false;
          $(".loader").hide();
        });
    },

    getBankAccts() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/BankAccounts/${this.branchId}`,
          configObject.authConfig()
        )
        .then((response) => {
          if (response.data !== null && response.data.length > 0) {
            this.accountNumber = response.data[0].accountNumber;
          }
          if (!response.data.length) {
            this.$toast.open({
              message: this.$t("text.shiftDeposits.bankAccountError"),
              type: "error",
              duration: 7000,
            });
          }
          this.bankAccounts = response.data;
        })
        .catch((error) => {});
    },
    decimalThousand(number) {
      if (!isFinite(number)) {
        return "0.00";
      }
      return number
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getShiftDeposits() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/ShiftDeposits/${this.$route.query.id}`,
          configObject.authConfig()
        )
        .then((response) => {
          let index = 0;
          this.count = response.data.length;
          response.data.forEach((element) => {
            element.index = ++index;
            element.amount = this.decimalThousand(element.amount);
            element.balance = this.decimalThousand(element.balance);
          });
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: response.data,
          });
          this.refreshGrid();
        })
        .catch((error) => {});
    },
    convertThousand(request) {
      return request; //.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>
